import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/site-data";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.07, ease: [0.2, 0.8, 0.2, 1] },
  }),
};

export const FAQ = () => {
  return (
    <section
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-[#EEF2EF]"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeUp}
          className="mb-12"
        >
          <div className="text-xs tracking-[0.28em] uppercase font-bold text-[#2E5C3E] mb-4">
            Frequently asked
          </div>
          <h2 className="font-['Outfit'] text-4xl md:text-5xl font-black tracking-tighter text-[#1A2E20] leading-[1.05] max-w-3xl">
            The stuff every Tallahassee homeowner asks before they hire.
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeUp}
          custom={1}
        >
          <Accordion
            type="single"
            collapsible
            className="rounded-3xl bg-white border border-[#D1DED5] divide-y divide-[#D1DED5]"
            data-testid="faq-accordion"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-b-0 px-6 md:px-8"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 font-['Outfit'] text-lg md:text-xl font-bold tracking-tight text-[#1A2E20] hover:no-underline text-left"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="pb-6 text-base text-[#4A6E55] leading-relaxed"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
